import { NgModule } from '@angular/core';
import { TitleComponent } from './title.component';


@NgModule({
  imports: [],
  declarations: [TitleComponent],
  exports: [TitleComponent],
  providers: [],
})
export class TitleModule { }
